import { KeyRisk } from './KeyRisk'

export default KeyRisk
